import { CHECKOUT_PLACED_ORDER, CHECKOUT_ADS, CHECKOUT_ANALYTICS } from '../actions/postOrderCheckout';

export const initialState = {
  address: null,
  analytics: null,
  creationDate: null,
  deliveryCharge: null,
  deliveryChargeSavings: null,
  deliverySlot: {
    startTime: null,
    endTime: null,
    earliestDownloadTime: null,
    cutoffTime: null,
  },
  discountClubSavings: null,
  finalAmount: null,
  orderNo: null,
  scribeContent: null,
  status: null,
  totalCostOfItems: null,
  totalSavings: null,
};

export default function checkout(state = initialState, action) {
  switch (action.type) {
    case CHECKOUT_PLACED_ORDER: {
      return { ...state, ...action.data };
    }
    case CHECKOUT_ADS: {
      return { ...state, scribeContent: action.scribeContent };
    }
    case CHECKOUT_ANALYTICS: {
      return { ...state, analytics: action.analytics };
    }
    default: {
      return state;
    }
  }
}
